import React from 'react';
import { Link } from 'react-router-dom';
import { tr } from '../../i18n';
import { operator } from './operator';
import './LegalDocumentLinks.css';

type LegalDocumentLinksProps = {
  variant: 'footer' | 'store';
  ariaLabel?: string;
};

const DocumentIcon: React.FC = () => (
  <svg className="legal-doc-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z" />
    <path d="M14 3v5h5M9 13h6M9 17h6" />
  </svg>
);

/** Постоянные кнопки-ссылки на оферту, условия и политику: футер и страница магазина. */
const LegalDocumentLinks: React.FC<LegalDocumentLinksProps> = ({ variant, ariaLabel }) => {
  const t = tr.shell.legal;
  return (
    <nav className={`legal-docs legal-docs--${variant}`} aria-label={ariaLabel ?? t.documentsTitle}>
      <span className="legal-docs-title">{t.documentsTitle}</span>
      <ul className="legal-docs-list">
        <li>
          <a href={operator.offerUrl} target="_blank" rel="noopener noreferrer" className="legal-doc-btn">
            <DocumentIcon />{t.offer}
          </a>
        </li>
        <li>
          <Link to="/terms" className="legal-doc-btn"><DocumentIcon />{tr.store.terms.heading}</Link>
        </li>
        <li>
          <Link to="/privacy" className="legal-doc-btn"><DocumentIcon />{tr.common.sidebar.privacyPolicy}</Link>
        </li>
      </ul>
    </nav>
  );
};

export default LegalDocumentLinks;
